@if (isOpen) {
  <div class="overlay">
    <div class="makeOffer shadow">
      <!-- <ng-container *ngIf="activeComponent">
      <component [ngComponentOutlet]="activeComponent"></component>
    </ng-container> -->
  </div>
</div>
}
